import { useEffect, useState } from "react";

// Прагове: мобилно < 480px (телефони), таблет 480–1023px, десктоп 1024–1439px, широк ≥ 1440px
// isNarrow (< 640) — семантично „тесен layout"; покрива телефоните + малки таблети в portrait,
// където колоните/chrome-а трябва да се свият, но екранът не е непременно телефон.
export const useViewport = () => {
  const get = () => {
    if (typeof window === "undefined") {
      return {
        isMobile: false,
        isNarrow: false,
        isTablet: false,
        isDesktop: true,
        isWide: false,
      };
    }
    const w = window.innerWidth;
    return {
      isMobile: w < 480,
      isNarrow: w < 640,
      isTablet: w >= 480 && w < 1024,
      isDesktop: w >= 1024,
      isWide: w >= 1440,
    };
  };

  const [vp, setVp] = useState(get);

  useEffect(() => {
    const onResize = () => setVp(get());
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  return vp;
};
